import { render, staticRenderFns } from "./TeacherBalance.vue?vue&type=template&id=ebfb8d6c&scoped=true&"
import script from "./TeacherBalance.vue?vue&type=script&lang=js&"
export * from "./TeacherBalance.vue?vue&type=script&lang=js&"
import style0 from "./TeacherBalance.vue?vue&type=style&index=0&id=ebfb8d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfb8d6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCol,VContainer,VRow})
